import { CheckCircle2, Zap, Target, Shield, Users, TrendingUp } from 'lucide-react';

export const VALUE_PROPS_SMB = [
  { icon: Zap, key: 'speed', translationKey: 'linkedin.valueProps.smb.speed' },
  { icon: Target, key: 'matching', translationKey: 'linkedin.valueProps.smb.matching' },
  { icon: Shield, key: 'certainty', translationKey: 'linkedin.valueProps.smb.certainty' },
  { icon: Users, key: 'simplicity', translationKey: 'linkedin.valueProps.smb.simplicity' },
];

export const VALUE_PROPS_VENDOR = [
  { icon: Target, key: 'qualified', translationKey: 'linkedin.valueProps.vendor.qualified' },
  { icon: TrendingUp, key: 'specialty', translationKey: 'linkedin.valueProps.vendor.specialty' },
  { icon: Users, key: 'inbound', translationKey: 'linkedin.valueProps.vendor.inbound' },
  { icon: CheckCircle2, key: 'free', translationKey: 'linkedin.valueProps.vendor.free' },
];

export const VALUE_PROPS_GENERAL = [
  { icon: Zap, key: 'aiPowered', translationKey: 'linkedin.valueProps.general.aiPowered' },
  { icon: Target, key: 'smartMatch', translationKey: 'linkedin.valueProps.general.smartMatch' },
  { icon: Shield, key: 'compliance', translationKey: 'linkedin.valueProps.general.compliance' },
  { icon: Users, key: 'bilingual', translationKey: 'linkedin.valueProps.general.bilingual' },
];
